import React from 'react'
import { IoBusiness, IoSchool, IoLocationSharp } from "react-icons/io5";
import { FaUniversity } from "react-icons/fa";
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

export default function Timeline() {

    const colors = [
        { bg: 'rgb(33, 150, 243)', arrow: 'rgb(33, 150, 243)' },   // blue
        { bg: '#78c506', arrow: '#78c506' }                       // green
    ];

    const items = [
        {
            date: "Jan 2025 - Jun 2025",
            company: "Vishkala Ventures",
            location: "Navi Mumbai, MH",
            subtitle: "SDE Intern",
            icon: <IoBusiness />
        },
        {
            date: "May 2024 - Jul 2024",
            company: "Bharat Heavy Electricals Limited",
            location: "Jagdishpur, UP",
            subtitle: "SDE Intern",
            icon: <IoBusiness />
        },
        {
            date: "Oct 2021 - Oct 2025",
            company: "Indian Institute of Information Technology",
            location: "Tiruchirappalli",
            subtitle: "Bachelor of Technology - CSE",
            icon: <FaUniversity />
        },
        {
            date: "Jul 2019 - Jul 2020",
            company: "Sunbeam English School",
            location: "Varanasi",
            subtitle: "Intermediate - CBSE",
            icon: <IoSchool />
        },
        {
            date: "May 2017 - May 2018",
            company: "St. Francis School",
            location: "Varanasi",
            subtitle: "High School - ICSE",
            icon: <IoSchool />
        }
    ];

    return (
        <VerticalTimeline lineColor="#78c506">
            {items.map((item, index) => {
                const c = colors[index % 2];

                return (
                    <VerticalTimelineElement
                        key={index}
                        date={item.date}
                        dateClassName="timeline-date"
                        contentStyle={{ background: c.bg, color: "#fff" }}
                        contentArrowStyle={{ borderRight: `7px solid ${c.arrow}` }}
                        iconStyle={{ background: c.bg, color: '#fff' }}
                        icon={item.icon}
                    >
                        <h3 className="timeline-company">{item.company}</h3>

                        <h4 className="timeline-location">
                            <IoLocationSharp size={16} style={{ marginRight: 6 }} />
                            {item.location}
                        </h4>

                        <h5 className="timeline-role">{item.subtitle}</h5>
                    </VerticalTimelineElement>
                );
            })}
        </VerticalTimeline>
    );
}
